module.exports = __webpack_public_path__ + "img/login-bg2.eb8b46b6.png";